module.exports = __webpack_public_path__ + "static/1 (11)-6b2a3181f30d40c5aeb48b7026af9912.png";